<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brandTe" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/basilur/basilurr.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/basilur/basilurr.svg" alt="" />
      <router-link to="/brandGreenIsland" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/basilur/p1.png'),
          require('../../assets/img/brands/basilur/p2.png'),
          require('../../assets/img/brands/basilur/p3.png'),
          require('../../assets/img/brands/basilur/p4.png'),
          require('../../assets/img/brands/basilur/p5.png'),
          require('../../assets/img/brands/basilur/p6.png'),
          require('../../assets/img/brands/basilur/p7.png'),
          require('../../assets/img/brands/basilur/p8.png'),
          require('../../assets/img/brands/basilur/p9.png'),
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <p>{{ $t('brands.basilur.desc') }}</p>
          <br />
          <p class="continets__text">{{ $t('brands.basilur.desc2') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/spetema/map-spetema.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>

<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';
.container__brand {
  background: #113b25 0% 0% no-repeat padding-box;
}
</style>